import config from './config'
import aws from './aws'
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser
} from 'amazon-cognito-identity-js'

const getCognitoUser = (user) => {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  })
  if (!user) {
    return userPool.getCurrentUser()
  }

  return new CognitoUser({ Username: user, Pool: userPool })
}

const getSession = (user) => {
  const cognitoUser = user || getCognitoUser()
  return new Promise((resolve, reject) => {
    cognitoUser.getSession((err, session) => {
      if (err) {
        reject(err)
        return
      }

      resolve(session)
    })
  })
}

const getUserToken = (user) => {
  return new Promise((resolve, reject) => {
    getSession(user).then(session => {
      resolve(session.getIdToken().getJwtToken())
    }).catch(err => {
      reject(err)
    })
  })
}

const checkLogin = async function () {
  const currentUser = getCognitoUser()

  if (currentUser === null) {
    return false
  }

  if (aws.credentialsValid()) {
    return true
  }

  const userToken = await getUserToken(currentUser)
  await aws.getAwsCredentials(userToken)

  return true
}

export default {
  login (user, password) {
    const userPool = new CognitoUserPool({
      UserPoolId: config.cognito.USER_POOL_ID,
      ClientId: config.cognito.APP_CLIENT_ID
    })
    const cognitoUser = new CognitoUser({ Username: user, Pool: userPool })
    const authenticationData = { Username: user, Password: password }
    const authenticationDetails = new AuthenticationDetails(authenticationData)

    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => resolve(cognitoUser),
        onFailure: err => reject(err)
      })
    })
  },

  signup (data) {
    const userPool = new CognitoUserPool({
      UserPoolId: config.cognito.USER_POOL_ID,
      ClientId: config.cognito.APP_CLIENT_ID
    })

    return new Promise((resolve, reject) => {
      userPool.signUp(data.user, data.password, null, null, (err, result) => {
        if (err) {
          reject(err)
          return
        }

        resolve(result.user)
      })
    })
  },

  verify (code, user) {
    const cognitoUser = getCognitoUser(user)

    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(code, true, (err, result) => {
        if (err) {
          reject(err)
          return
        }

        resolve(result)
      })
    })
  },

  signout () {
    const cognitoUser = getCognitoUser()

    cognitoUser.signOut()
  },

  getGroups: async function () {
    const session = await getSession()
    return session.getIdToken().payload['cognito:groups']
  },

  checkLogin
}



// WEBPACK FOOTER //
// ./src/api/user.js